import { useEffect, useState } from 'react';
import { MdAccountTree, MdPieChart } from 'react-icons/md';
import { ChipDropdown } from '../ChipDropdown';
import { COMPETITOR_OPTIONS, MARKET_SHARE_OPTIONS } from '../../constants';
import styles from './Header.module.scss';
import { useVisaoGeralElasticidadeStore } from '../../VisaoGeralElasticidade.store';
import { getIndustryDataFreshness } from '../../services';
import { formatIsoDateToBr } from '../../utils';

export const Header = () => {
  const [selecteMarketShareOption, setSelecteMarketShareOption] = useState<string>('Market share por valor de vendas');
  const [selectedCompetitorOption, setSelectedCompetitorOption] = useState<string>('Top produto concorrente');
  const [lastUpdatedAt, setLastUpdatedAt] = useState<string>('--');
  const { setMarketShareOption, setCompetitorOption } = useVisaoGeralElasticidadeStore();

  useEffect(() => {
    let active = true;

    getIndustryDataFreshness()
      .then(data => {
        if (active) setLastUpdatedAt(formatIsoDateToBr(data?.lastUpdatedAt));
      })
      .catch(() => {
        if (active) setLastUpdatedAt('--');
      });

    return () => {
      active = false;
    };
  }, []);

  const handleSelectOption = (type: 'marketShare' | 'competitor', value: string) => {
    const nextLabelByType = {
      marketShare: {
        'valor-vendas': 'Market share por valor de vendas',
        'volume-vendas': 'Market share por volume de vendas',
      },
      competitor: {
        'produto-concorrente': 'Top produto concorrente',
        'media-precos-concorrentes': 'Média de preços dos produtos concorrentes',
      },
    } as const;

    if (type === 'marketShare') {
      const nextLabel = nextLabelByType.marketShare[value as keyof typeof nextLabelByType.marketShare];
      if (!nextLabel) return;
      setMarketShareOption(value as 'valor-vendas' | 'volume-vendas');
      setSelecteMarketShareOption(nextLabel);
      return;
    }

    const nextLabel = nextLabelByType.competitor[value as keyof typeof nextLabelByType.competitor];
    if (!nextLabel) return;
    setSelectedCompetitorOption(nextLabel);
    setCompetitorOption(value as 'produto-concorrente' | 'media-precos-concorrentes');
  };

  return (
    <header className={styles.header}>
      <div className={styles.content}>
        <div className={styles.headingRow}>
          <h1 className={styles.title}>Visão geral de elasticidade</h1>
          <p className={styles.updatedAt}>{`Última atualização semanal: ${lastUpdatedAt}`}</p>
        </div>
        <p className={styles.description}>
          Entenda como a variação de preço de produtos concorrentes impacta o market share do seu portfólio, identificando oportunidades competitivas.
        </p>
      </div>

      <div className={styles.actions}>
        <div className={styles.marketShareOption}>
          <MdPieChart size={14} />
          <span>Market share por valor de vendas</span>
        </div>
        <div className={styles.marketShareOption}>
          <MdAccountTree size={14} />
          <span>Top produto concorrente</span>
        </div>

        {/* TODO: Manter os componentes abaixo para usar futuramente, substituindo os dois componentes acima */}
        {/* <ChipDropdown
          icon={<MdPieChart size={14} />}
          label={selecteMarketShareOption}
          options={MARKET_SHARE_OPTIONS}
          onSelect={value => handleSelectOption('marketShare', value)}
          data-testid="visao-geral-elasticidade-market-share-chip"
        /> */}
        {/* <ChipDropdown
          icon={<MdAccountTree size={14} />}
          label={selectedCompetitorOption}
          options={COMPETITOR_OPTIONS}
          onSelect={value => handleSelectOption('competitor', value)}
          data-testid="visao-geral-elasticidade-top-concorrente-chip"
        /> */}
      </div>
    </header>
  );
};
